import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import ShieldSpinner from "@/components/ShieldSpinner";

export default function PdfLoadingOverlay() {
  const [count, setCount] = useState(0);
  useEffect(() => {
    const on = (e) => setCount((c) => Math.max(0, c + (e.detail || 0)));
    window.addEventListener("mfg:pdf-busy", on);
    return () => window.removeEventListener("mfg:pdf-busy", on);
  }, []);
  if (!count) return null;
  return createPortal(
    <div className="fixed inset-0 z-[1200] bg-[#050A16]/70 backdrop-blur-sm flex items-center justify-center animate-in fade-in" data-testid="pdf-loading-overlay">
      <div className="rounded-2xl bg-white/95 shadow-2xl px-10 py-6 border border-white/40">
        <ShieldSpinner size="lg" label="Preparing your document…" testId="pdf-loading-spinner" />
        <div className="text-[11px] text-neutral-400 text-center -mt-1">MFG · branded PDF rendering</div>
      </div>
    </div>,
    document.body,
  );
}
